import { isEmpty } from "../../../common/helper/helper"
import { useEffect, useState } from "react"
import { IEventProps } from "./EventRegForm"

export const useFetchCCEvent = (eventId: number | string, contentId: number | string, isSubmitted: boolean) => {
    const [eventData, setEvent] = useState<IGetCCEventResponse>({ success: false });
    useEffect(() => {
        (async () => {
            try {
                const url = `/Umbraco/Api/Event/GetCCEventModel?eventId=${eventId}&contentId=${contentId}`
                const ccEvent: IEventProps = await fetch(url, { method: "GET", })
                    .then((resp) => resp.json())

                if (ccEvent != null && !isEmpty(ccEvent)) {
                    setEvent({ success: true, data: ccEvent })
                } else {
                    setEvent({ success: false, message: "No event data found" })
                }
            } catch (e) {
                setEvent({ success: false, message: "No event data found" })
            }
        })();
    }, [isSubmitted])
    return eventData
}

export interface IGetCCEventResponse {
    success: boolean
    message?: string
    data?: IEventProps
}